import { BLUE_500 } from '../colors';
var tooltipConfig = {
  isVisible: false,
  showCross: false,
  autoHide: true,
  autoHideTimeout: 5000,
  position: 'top-center',
  backgroundColor: BLUE_500,
  offset: {
    x: 0,
    y: 0,
    start: 0,
    center: 0,
    end: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  config: {
    padding: 8,
    borderRadius: 8
  }
};
export default {
  light: tooltipConfig,
  dark: tooltipConfig,
  white: tooltipConfig
};